import React, { useState, useEffect, useMemo } from "react";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { getStorageUser } from "../../helpers/api_helper";

const DashboardBia = () => {
  document.title = "RT - BIA | Sistema de Logística";
  const user = getStorageUser();
  let url = "";
  if (user.route?.id == 35) {
    url = "https://selva-negra.accesa.me/consulta"
  }
  if (user.route?.id == 61) {
    url = "https://juchitan.accesa.me/consulta"
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="" breadcrumbItem="Tiempo Real BIA" />

          <Row>
            <Col xl="12">
              <Card>
                <CardBody className="p-0">
                  { url != "" && (
                  <iframe
                    scrolling="true"
                    width="100%"
                    height={window.innerHeight - 200}
                    style={{ border: "none", overflow: "scroll", overflowY: "scroll", padding: '15px'}}
                    src={url}
                    title="BIA"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                  )}
                  { url == "" && (
                    <div className="text-center">
                      <Spinner color="primary" />
                      <h4 className="mt-3">Cargando...</h4>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default DashboardBia;
